import { render, staticRenderFns } from "./MagazineOverview.vue?vue&type=template&id=14ddadf6"
import script from "./MagazineOverview.vue?vue&type=script&lang=js"
export * from "./MagazineOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports